<template>
  <div
    v-if="displayApiOfflineOverlay"
    class="fixed inset-0 z-100 flex items-center justify-center bg-black bg-opacity-85"
  >
    <div class="bg-white p-4 rounded-lg">
      <div class="flex flex-col items-center justify-center">
        <h1 v-if="!isApiAvailable" class="text-2xl font-bold text-center">Connection Lost</h1>
        <h1 v-if="showReloadButton && isApiAvailable" class="text-2xl font-bold text-center">
          Connection Restored
        </h1>
        <p v-if="!isApiAvailable" class="text-sm mt-2">
          We're unable to connect to the server right now.
        </p>
        <p v-if="showReloadButton && isApiAvailable" class="text-sm mt-2">
          We're able to connect to the server again. Please reload the page.
        </p>
        <div v-if="!showReloadButton" class="flex flex-col items-center justify-center mt-4 mb-4">
          <div
            class="animate-spin rounded-full h-6 w-6 border-b-2 border-dashboard-blue mb-2"
          ></div>
          <div class="text-sm text-gray-600">Attempting to reconnect to the server…</div>
        </div>
        <TwcButton v-if="showReloadButton" class="mt-4" secondary xsmall @click="handleReload">
          Reload Page
        </TwcButton>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { ref, watch } from 'vue'
import { useApiStatusStore } from '@/stores/api-status'
import TwcButton from '@/components/web-components/TwcButton.vue'

const apiStatusStore = useApiStatusStore()
const displayApiOfflineOverlay = ref(false)
const { isApiAvailable } = storeToRefs(apiStatusStore)

const showReloadButton = ref(false)
const timeoutId = ref<number | null>(null)

const handleReload = () => {
  window.location.reload()
}

watch(isApiAvailable, (newValue, oldValue) => {
  if (timeoutId.value) {
    clearTimeout(timeoutId.value)
    timeoutId.value = null
  }

  if (newValue) {
    showReloadButton.value = true
  } else {
    displayApiOfflineOverlay.value = true
    showReloadButton.value = false

    if (oldValue) {
      timeoutId.value = window.setTimeout(() => {
        showReloadButton.value = true
      }, 60_000)
    }
  }
})
</script>
